(function(CassiopeaTypesEnum) {
	'use strict';

	function NavigationManagerUtilsFactory(dcyDPService, dcyUtilsFactory) {
		
		var RESOURCE_TYPE_ENUM = {
				ROOT 			: '0',
				FOLDER 			: '1',
				FILE 			: '2',
				SPECIAL_FILE 	: '3',
				SPECIAL_FOLDER 	: '4',
		},
		
		iconsDefaultMap = {
				'0': 'book-variant',
				'1': 'folder',
				'2': 'file',
				'3': 'file-lock',
				'4': 'folder-lock'
		},
		
		iconsByCasTypeMap = {};		
		iconsByCasTypeMap[CassiopeaTypesEnum.REPORT] 				=  'view-comfy';		
		iconsByCasTypeMap[CassiopeaTypesEnum.MSH] 					=  'dashboard';		
		iconsByCasTypeMap[CassiopeaTypesEnum.SOCIAL_AREA_NORMAL] 	=  'dcy-area-icon';
		iconsByCasTypeMap[CassiopeaTypesEnum.SOCIAL_AREA_GROUP] 	=  'dcy-group-icon';
		iconsByCasTypeMap[CassiopeaTypesEnum.SOCIAL_AREA_INITIATIVE]=  'dcy-initiative-icon';		
		iconsByCasTypeMap[CassiopeaTypesEnum.SOCIAL_DOCUMENT] 		=  'dcy-document-icon';
		iconsByCasTypeMap[CassiopeaTypesEnum.SOCIAL_BLOG] 			=  'blogger';
		iconsByCasTypeMap[CassiopeaTypesEnum.PLANNING] 				=  'process';

		/**
		 * Retrieve icon from type
		 * @param  {string} type type of selected node
		 * @return {string}      return a material icon
		 */
		function getIcon(iconsMap, type, templateType) {
			var icon;
			
			if(angular.isObject(iconsMap)){
				icon = iconsMap[type] || iconsMap[templateType];
			}
			
			if(!icon){
				icon = iconsDefaultMap[type] || iconsDefaultMap[templateType];
			}
			
			return icon;
		}
		
		function getIconByCassiopeaType(cassiopeaType){			
			return iconsByCasTypeMap[cassiopeaType] ;
		}
		
		function getIconByElement(element, iconsMap) {
			var icon;
			var type = element.type;
			
			if(angular.isObject(iconsMap)){
				icon = iconsMap[type];
			}
			if(!icon){
				switch (type) {
					case RESOURCE_TYPE_ENUM['ROOT']:
					case RESOURCE_TYPE_ENUM['FOLDER']:
						icon = iconsDefaultMap[type] ;
						break;
					case RESOURCE_TYPE_ENUM['FILE']:
						// case 1030: report type: crosstab; case 1040: report type: graph; case 1050: report type: document
						if (element.nodeInfo.casType === 1030 || element.nodeInfo.casType === 1040 || element.nodeInfo.casType === 1050){
							icon = iconsByCasTypeMap[CassiopeaTypesEnum.REPORT] ;
						}else{
							icon = iconsByCasTypeMap[element.nodeInfo.casType] ;
						}
						break;
					default:
						break;
				}
			}
			return icon;
		}
		
		function isBaseFolder(nodeType){
			return angular.equals(nodeType.toString(), RESOURCE_TYPE_ENUM.SPECIAL_FOLDER);
		}
		
		function isRootFolder(nodeType){
			return (angular.equals(nodeType.toString(), RESOURCE_TYPE_ENUM.ROOT));
		}
		
		function isFolder(nodeType){
			return (angular.equals(nodeType.toString(), RESOURCE_TYPE_ENUM.ROOT) || angular.equals(nodeType.toString(), RESOURCE_TYPE_ENUM.FOLDER) || isBaseFolder(nodeType));
		}
		
		function isBaseFile(nodeType){
			return angular.equals(nodeType.toString(), RESOURCE_TYPE_ENUM.SPECIAL_FILE);
		}
		
		function isFile(nodeType){
			//File or special File
			return (angular.equals(nodeType.toString(), RESOURCE_TYPE_ENUM.FILE) || isBaseFile(nodeType.toString()));
		}
		
		function getFilterToChange(actualFilterData, nodeInfo){
			return (actualFilterData+'.nodes.'+nodeInfo.id);
		}
		
		function parentToChange($event, nodeInfo){
			var filterSplitted = nodeInfo.filter.split('.');
				
			if(filterSplitted.length >= 3){
				filterSplitted.splice(-2, 2);
				
				return filterSplitted.toString().replace(/,/g, '.');
			}
		}
		
		function getResourceTypeSupported(){
			return RESOURCE_TYPE_ENUM;
		}
		
		function getParentFilterByNodeInfo(nodeInfo){
	    	var arrayFilter = nodeInfo.filter.split('.');
			arrayFilter.splice(arrayFilter.length-2, arrayFilter.length);
			return (arrayFilter.toString()).replace(/,/g,'.');
	    }
	    
		function adapterNodesInfoFromAction(nodes, owner){
	    	var selectedObject = new Array();
	    	_.forEach(nodes, function(node){
				selectedObject.push({
					id 		: node.nodeInfo.id || node.id, 
					name 	: node.nodeInfo.name,
					type 	: node.type,
					owner 	: owner
				});
			});
	    	return selectedObject;
	    }
	    
		function getFlatTree(tree, leafIsViewable, ordering, searchText) {
			let flatList = [];
			
			let nodes = {};
			
			if(tree && isRootFolder(tree.type)){
				nodes[tree.id] = tree;
			}
			else{
				nodes = tree;
			}
			
			_.forEach(nodes, node => {
				visitTreeNode(node, flatList, leafIsViewable, ordering);
			});
			
			return flatList;
		}

		function visitTreeNode(node, flatList, leafIsViewable, ordering) {
			if(isFile(node.type) && leafIsViewable == 'false'){
				return;
			}
			
			if (flatList && node.nodeInfo.visible) {
				node.nodeInfo.vIndex = flatList.length;
				flatList.push(node);
			}

			if (node.nodeInfo.expanded && node.nodes) {
				var nodes = ordering.isActive ? _.orderBy(node.nodes, ordering.identity, ordering.orders) : node.nodes;
				_.forEach(nodes, function(child) {
					visitTreeNode(child, flatList, leafIsViewable, ordering);
				});
			}
		}
		
		return {
			getIcon						: getIcon,
			isFolder 					: isFolder,
			isBaseFolder				: isBaseFolder,
			getFilterToChange 			: getFilterToChange,
			parentToChange 				: parentToChange,
			isFile 						: isFile,
			isBaseFile					: isBaseFile,
			getResourceTypeSupported	: getResourceTypeSupported,
			getParentFilterByNodeInfo	: getParentFilterByNodeInfo,
			adapterNodesInfoFromAction	: adapterNodesInfoFromAction,
			getFlatTree					: getFlatTree,
			isRootFolder				: isRootFolder,
			getIconByCassiopeaType		: getIconByCassiopeaType,
			getIconByElement			: getIconByElement
		};
	}

	NavigationManagerUtilsFactory.$inject = ['dcyDPService', 'dcyUtilsFactory'];

	angular
	.module('dcyApp')
	.register
	.factory('dcyNavigationManagerUtilsFactory', NavigationManagerUtilsFactory);

}(window.CassiopeaTypesEnum));
